import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.13.0_@parcel+watcher@2.5.1_@types+node@20.10.1_db0@0.3.2_encoding@0.1.13_eslint@_33360446c538a4775ce6601c843b1073/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/app/app/platform/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}